import { useState } from 'react'

// Copy verbatim from the 29.09 canvas note (spec §2.7); the frames draw only answer 1.
const FAQS = [
  {
    q: 'How does Arvance find comparable properties?',
    a: 'Arvance searches nearby sold, pending, and active properties, then scores them using factors such as similarity, distance, and recency. You can adjust the search criteria and choose which comps influence your ARV estimate.',
  },
  {
    q: 'Why use Arvance instead of a spreadsheet?',
    a: 'Arvance brings property data, comp analysis, deal projections, and pipeline tracking into one workflow. Compare scenarios and update assumptions without rebuilding formulas or managing separate files.',
  },
  {
    q: 'Is Arvance beginner-friendly?',
    a: 'Yes. Arvance is designed to be easy to follow while keeping every assumption visible and editable. Newer investors get a guided workflow, while experienced investors keep control over the analysis.',
  },
  {
    q: 'Can I choose the comps and customize my assumptions?',
    a: 'Yes. You decide which comparable properties influence the ARV estimate and can customize financing, purchase, rehab, holding, selling, and exit assumptions.',
  },
  {
    q: 'How accurate are the projections?',
    a: 'Arvance calculates projections using available property data, the comps you select, and the assumptions you enter. Because market conditions and deal costs can change, the results are estimates, not appraisals or guarantees.',
  },
]

// 16px plus / minus, stroke 2. D11: the open minus is #43B017 on desktop, #4AA52A on mobile.
const Icon = ({ open }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    strokeWidth="2"
    aria-hidden="true"
    className={`shrink-0 ${open ? 'stroke-brand-accent canvas:stroke-[#43B017]' : 'stroke-brand-dark'}`}
  >
    <path d="M0 8h16" />
    {!open && <path d="M8 0v16" />}
  </svg>
)

// Figma 29.09 `faq_2` / `faq`: every row is 24 + question + 23 + a 1px divider, the first without
// its top 24 so it lines up with the heading. Bottom padding 40 / 64 follows the new design and
// replaces the earlier 60 / 72 correction (letter 97 p.5).
const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0)

  const toggle = (i) => setOpenIndex((current) => (current === i ? -1 : i))

  return (
    <section id="faq" className="bg-brand-band">
      <div className="max-w-[640px] canvas:max-w-canvas mx-auto px-5 canvas:px-0 pt-10 canvas:pt-16 pb-10 canvas:pb-16 flex flex-col canvas:flex-row justify-between gap-[42px] canvas:gap-12">
        <h2 className="canvas:w-[352px] canvas:shrink-0 text-[28px] leading-9 canvas:text-[36px] canvas:leading-[48px] font-extrabold text-brand-dark text-center canvas:text-left">
          Common Questions,
          <br />
          <span className="text-brand-accent">Clear Answers</span>
        </h2>

        <div className="w-full canvas:w-[732px] flex flex-col">
          {FAQS.map(({ q, a }, i) => {
            const isOpen = openIndex === i
            return (
              // D12: the dividers are #A7C199 on mobile and #AEC49F on desktop.
              <div
                key={q}
                className="pt-6 first:pt-0 pb-[23px] border-b border-brand-arvBorder canvas:border-[#AEC49F] flex flex-col gap-4"
              >
                <button
                  type="button"
                  onClick={() => toggle(i)}
                  aria-expanded={isOpen}
                  className={`flex items-center justify-between gap-4 text-left ${
                    isOpen ? 'text-brand-accent' : 'text-brand-dark'
                  }`}
                >
                  <span className="text-[18px] leading-6 canvas:text-[20px] canvas:leading-8 font-bold">{q}</span>
                  <span className="w-[18px] shrink-0 flex justify-start">
                    <Icon open={isOpen} />
                  </span>
                </button>
                {isOpen && (
                  <p className="text-[16px] leading-6 canvas:leading-7 text-brand-dark">{a}</p>
                )}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default Faq
